import { Globe, Brain, Sparkles, User } from "lucide-react"

// Shared model information with modern icons and descriptive names
export const MODEL_INFO = {
  "ollama:gpt-4o": {
    name: "ollama: GPT-4 Optimized",
    icon: <Globe className="h-4 w-4" />,
    provider: "OpenAI"
  },
  "ollama:anthropic:claude-3-5-sonnet-latest": {
    name: "ollama: Claude 3.5 Sonnet",
    icon: <Brain className="h-4 w-4" />,
    provider: "Anthropic"
  },
  "ollama:ollama:qwen2.5-coder:32b": {
    name: "ollama: Qwen 2.5 Coder",
    icon: <Sparkles className="h-4 w-4" />,
    provider: "Qwen"
  },
  "ollama:ollama:qwq:32b-preview-fp16": {
    name: "ollama: QWQ Preview",
    icon: <Sparkles className="h-4 w-4" />,
    provider: "QWQ"
  }
} as const

export const getModelIconAndName = (model: string) => {
  if (!model || model === 'user') return { name: "You", icon: <User className="h-4 w-4"/>, provider: "User" }
  
  // Parse provider:model format
  const [provider, modelName] = model.split(':')
  if (!modelName) {
    return { name: model, icon: <User className="h-4 w-4"/>, provider: "Unknown" }
  }

  const info = MODEL_INFO[model as keyof typeof MODEL_INFO]
  if (info) return info

  // If not in MODEL_INFO, return parsed values
  return { 
    name: modelName, 
    icon: <Sparkles className="h-4 w-4"/>, 
    provider: provider.charAt(0).toUpperCase() + provider.slice(1)
  }
}
